import {
    LanguageWithWildcard,
    MechanicPath,
    MechanicFilter,
    useMechanicsLocationsQuery,
    useMechanicsLocationsLazyQuery,
} from "@/shared/services/graphql/generated/consumer-graph-types";
import { computed, Ref } from "vue";

export interface useMechanicLocationParams {
    first?: number;
    acceptedLanguages?: Array<LanguageWithWildcard>;
    articleId?: string;
    mechanicId?: string;
    product: string;
    asset?: string;
}

export function useMechanicLocation(params: Ref<useMechanicLocationParams>) {
    const filter = computed<MechanicFilter>(() => {
        const filter = {
            ...(params.value.articleId !== undefined && {
                equals: { articleId: params.value.articleId, product: params.value.product },
            }),
            ...(params.value.mechanicId !== undefined && { ids: [params.value.mechanicId] }),
        };
        return filter;
    });

    const queryParams = computed(() => {
        return {
            first: params.value.first,
            filter: filter.value,
            assetId: params.value.asset,
            productId: params.value.product,
            acceptedLanguages: params.value.acceptedLanguages,
        };
    });

    const { loading, error, result, fetchMore } = useMechanicsLocationsQuery(
        queryParams,
        // TODO: mit Cache werden das immer mehr Daten alles was schon mal abgefragt wurde ist dann doppelt, siehe QIT-1685
        { fetchPolicy: "no-cache", enabled: params.value.articleId !== "" || params.value.mechanicId !== "" }
    );

    const { load } = useMechanicsLocationsLazyQuery(queryParams, {
        fetchPolicy: "no-cache",
        enabled: params.value.articleId !== "" || params.value.mechanicId !== "",
    });

    const paths = computed(() => {
        const result: Array<MechanicPath> = [];
        mechanics.value?.mechanics.forEach((mechanic) => {
            mechanic?.node.pathsToRoot?.forEach((path) => {
                result.push(path as MechanicPath);
            });
        });
        return result;
    });

    const mechanics = computed(() => {
        return result.value?.mechanics;
    });

    async function loadPaths() {
        const result = await load();
        if (result) {
            const paths: Array<MechanicPath> = [];
            result.mechanics.mechanics.forEach((mechanic) => {
                mechanic?.node.pathsToRoot?.forEach((path) => {
                    paths.push(path as MechanicPath);
                });
            });
            return paths;
        }
        return [];
    }

    return {
        loading,
        error,
        mechanics,
        paths,
        fetchMore,
        loadPaths,
    };
}
